import { DEFAULT_SIDEBAR_WIDTH, MIN_SIDEBAR_WIDTH } from 'play/atoms/assignment-sidebar/AssignmentSidebar';

export function getSidebarWidth(configuredWidth: number | undefined) {
  if (configuredWidth === undefined) {
    return DEFAULT_SIDEBAR_WIDTH;
  }

  return Math.max(window.innerWidth * (configuredWidth / 100), MIN_SIDEBAR_WIDTH);
}
